import { render, staticRenderFns } from "./PremiumMembershipSection.vue?vue&type=template&id=50c21ffd&scoped=true"
import script from "./PremiumMembershipSection.vue?vue&type=script&lang=js"
export * from "./PremiumMembershipSection.vue?vue&type=script&lang=js"
import style0 from "./PremiumMembershipSection.vue?vue&type=style&index=0&id=50c21ffd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c21ffd",
  null
  
)

export default component.exports